import { heroData } from '@/mocks/homeData';

export default function HeroSection() {
  const { tag, h1, h1Sub, slogan, description, description2, stats, primaryCta, secondaryCta } = heroData;

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[64px] bg-background-950 overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20dramatic%20background%20with%20warm%20crimson%20and%20deep%20black%20gradient%2C%20flowing%20energy%20waves%20with%20golden%20particles%2C%20mysterious%20atmosphere%20suggesting%20secrets%20and%20revelations%2C%20editorial%20magazine%20style%2C%20luxurious%20dark%20texture%20with%20subtle%20light%20streaks%2C%20modern%20minimal%20composition%2C%20no%20text%20no%20people&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="51吃瓜网今日吃瓜资源背景"
          className="w-full h-full object-cover object-top opacity-60"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/70"></div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-semibold text-accent-400 bg-accent-500/15 rounded-full mb-5 tracking-wide">
              {tag}
            </span>

            <h1 className="text-[28px] md:text-[42px] lg:text-[48px] font-black text-background-50 font-heading leading-tight mb-3">
              {h1}
              <span className="block text-accent-400 text-[22px] md:text-[28px] lg:text-[30px] font-semibold mt-1">
                {h1Sub}
              </span>
            </h1>

            <p className="text-[16px] md:text-[18px] text-accent-300 font-medium mb-6 font-heading italic">
              {slogan}
            </p>

            <p className="text-[14px] md:text-[15px] text-background-300 leading-relaxed mb-3 max-w-[580px] lg:max-w-none">
              {description}
            </p>
            <p className="text-[14px] md:text-[15px] text-background-300 leading-relaxed mb-7 max-w-[580px] lg:max-w-none">
              {description2}
            </p>

            <div className="flex items-center gap-4 md:gap-6 mb-8 justify-center lg:justify-start flex-wrap">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-[22px] md:text-[26px] font-black text-accent-400 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-[12px] text-background-400 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex items-center gap-3 justify-center lg:justify-start flex-wrap">
              <a
                href={primaryCta.href}
                className="inline-flex items-center gap-2 px-6 py-3 text-[15px] font-bold bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-all whitespace-nowrap no-underline"
              >
                <i className="ri-play-circle-line text-lg"></i>
                {primaryCta.text}
              </a>
              <a
                href={secondaryCta.href}
                className="inline-flex items-center gap-2 px-6 py-3 text-[15px] font-semibold text-background-50 border border-background-400/40 rounded-md hover:bg-background-50/10 transition-all whitespace-nowrap no-underline"
              >
                <i className="ri-fire-line text-lg"></i>
                {secondaryCta.text}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=dark%20editorial%20magazine%20cover%20style%20design%2C%20abstract%20breaking%20news%20concept%20with%20warm%20crimson%20and%20gold%20accents%2C%20dynamic%20geometric%20composition%20with%20flowing%20lines%2C%20mysterious%20and%20premium%20atmosphere%2C%20bold%20visual%20impact%2C%20luxurious%20dark%20texture%20background%2C%20no%20text%20no%20people%2C%20modern%20design%20aesthetic&width=800&height=600&seq=hero-visual-main&orientation=landscape"
                alt="51吃瓜网今日吃瓜资源 - 最新爆料黑料合集"
                className="w-full h-auto object-cover rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}